import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';

const CompanyCreate = (props) => {
    const history = useHistory();

    const [name, setName] = useState("");
    const [companyCode, setCompanyCode] = useState("");
    const [contactNumber1, setContactNumber1] = useState("");
    const [contactNumber2, setContactNumber2] = useState("");
    const [email, setEmail] = useState("");
    const [gstNumber, setGstNumber] = useState("");
    const [website, setWebsite] = useState("");
    const [addressLine, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [pincode, setPostcode] = useState("");
    const [city, setCity] = useState("");
    const [district, setDistrict] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [pinCodes, setPinCodes] = useState([]);

    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('PinCodeApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setPinCodes(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching PIN codes:', error);
            });
    }, []);

    const handlePinCodeChange = (event) => {
        const value = event;
        if (value.length === 6) {
            const selectedPinCode = pinCodes.find(pinCode => pinCode.Postcode === value);
            if (selectedPinCode) {
                setCity(selectedPinCode.City);
                setDistrict(selectedPinCode.District);
                setPostcode(selectedPinCode.Postcode);
                setCountry(selectedPinCode.Country);
                setState(selectedPinCode.State);
            }
        }
    };

    const handleNameChange = (event) => {
        const newName = event.target.value;
        setName(newName);

        // Auto-generate company code (Example: converting "My Company" to "MYC123" with a random number)
        const generatedCode = newName
            .toUpperCase()
            .split(' ')
            .map((word) => word.charAt(0))
            .join('');

        // Add a random number or unique identifier to the generated code
        const randomNumber = Math.floor(100 + Math.random() * 900); // Generates a random 3-digit number
        const finalCode = `${generatedCode}${randomNumber}`;

        setCompanyCode(finalCode);
    };


    const clearForm = () => {
        setName("");
        setCompanyCode("");
        setContactNumber1("");
        setContactNumber2("");
        setEmail("");
        setGstNumber("");
        setWebsite("");
        setAddressLine1("");
        setAddressLine2("");
        setPincode("");
        setCity("");
        setDistrict("");
        setState("");
        setCountry("");
    };


    const submitData = async (e) => {
        e.preventDefault();
        if (!name || !contactNumber1) {
            setErrorMessage("All fields are required!");
            return;
        }

        const CompanyCreateData = {
            Name: name,
            CompanyCode: companyCode,
            ContactNumber1: contactNumber1,
            ContactNumber2: contactNumber2,
            Email: email,
            GSTNumber: gstNumber,
            Website: website,
            Addressline1: addressLine,
            Addressline2: addressLine2,
            Pincode: pincode,
            City: city,
            District: district,
            State: state,
            Country: country,
            CreatedBy: 1,
            CreatedDate: new Date(),
        };

        postData('CompanyApi', CompanyCreateData, token)
            .then((response) => {
                console.log('Company Created success:', response);
                setSuccessMessage("Company Created successful!");
                setErrorMessage("");
                clearForm();
                history.push('/companyIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Company Create error:', error);
            });
    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    /* End API */

    return (

        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>

                    <div className='w-full mb-2 flex'>
                        <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>COMPANY CREATE</h5>
                        <Button
                            variant="contained"
                            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                            onClick={submitData}
                        >
                            SAVE
                        </Button>

                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/companyIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            BACK TO LIST
                        </Button>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Company Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={handleNameChange}
                                type="text"
                                placeholder="Enter Company name"
                                required
                                maxLength={50}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Company Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={companyCode}
                                onChange={(e) => setCompanyCode(e.target.value)}
                                type="text"
                                placeholder="Enter Company Code"
                                readOnly
                            />
                        </div>
                    </div>


                    <div className="w-full mb-4 flex">

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Contact Number 1
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={contactNumber1} onChange={(e) => setContactNumber1(e.target.value)} type="text" placeholder="Enter Contact Number 1"
                                required
                                maxLength={15}
                                pattern={phoneNumberPattern.source}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Contact Number 2
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={contactNumber2} onChange={(e) => setContactNumber2(e.target.value)} type="text" placeholder="Enter Contact Number 2"
                                maxLength={15}
                                pattern={phoneNumberPattern.source}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Email
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={email} onChange={(e) => setEmail(e.target.value)} type="text" placeholder="Enter Email"
                                maxLength={30}
                                pattern={emailPattern.source}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                GST Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} maxLength={15} type="text" placeholder="Enter GST Number" />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Address Line 1
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={addressLine} onChange={(e) => setAddressLine1(e.target.value)} type="text" placeholder="Enter Address Line 1"
                                maxLength={200}
                                required
                            />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Address Line 2
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={addressLine2} onChange={(e) => setAddressLine2(e.target.value)} type="text" placeholder="Enter Address Line 2"
                                maxLength={200}
                            />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                PIN Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={pincode}
                                name="pincode"
                                onChange={(e) => setPostcode(e.target.value)}
                                type="text"
                                placeholder="Enter Pin Code"
                                list="pinCodesList"
                                onBlur={(e) => handlePinCodeChange(e.target.value)} // Handle pin code change onBlur
                                required
                            />
                            <datalist id="pinCodesList">
                                {pinCodes.map((pinCode) => (
                                    <option key={pinCode.Id} value={pinCode.Postcode} />
                                ))}
                            </datalist>
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                City
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={city} onChange={(e) => setCity(e.target.value)} type="text" placeholder="Enter City" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                District
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={district} onChange={(e) => setDistrict(e.target.value)} type="text" placeholder="Enter District" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                State
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={state} onChange={(e) => setState(e.target.value)} type="text" placeholder="Enter State" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Country
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={country} onChange={(e) => setCountry(e.target.value)} type="text" placeholder="Enter Country" readOnly />
                        </div>


                    </div>


                </form>
            </div>
        </Fragment>
    );
}


export default CompanyCreate;


